const getCookiesNames = projectId => ({
  locale: `xl-${projectId}-loc`,
  theme: `xl-${projectId}:theme`
});

module.exports = {
  getCookiesNames
};



// WEBPACK FOOTER //
// ../common/cookie.js